//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		props: {
			data: {
				type: String
			},
			title: {
				type: String
			},
			error: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				swiperOption: {
					direction: 'vertical',
					slidesPerView: 'auto',
					freeMode: true,
					scrollbar: {
						el: '.swiper-scrollbar',
						hide: true,
						draggable: true
					},
					mousewheel: true,
					observer: true,
					observeParents: true
				}
			}
		},
		computed: {
			commonData() {
				if (this.data) {
					return JSON.parse(this.data)
				}
			}
		}
	}




// WEBPACK FOOTER //
// ./src/components/commonlist.vue